import { Typography, Card, CardContent, Box, Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { toast } from "react-toastify";
import config from "../../utils/config";

const costPerStudent = 0.01;

const emptyChartData = {
	labels: [],
	datasets: [
		{
			data: [],
			backgroundColor: [],
		},
	],
};

function Finance(props) {
	const [timestamp, setTimestamp] = useState(moment());
	const [totalCost, setTotalCost] = useState(0);
	const [activeStudentData, setActiveStudentData] = useState(emptyChartData);

	useEffect(() => {
		props.setTitle("Finance");
	}, []); //eslint-disable-line

	useEffect(() => {
		axios.get(`${config.API_ENDPOINT}/metrics/monthly/${props.organization}?metricName=active-students&timestamp=${timestamp.valueOf()}`, { headers: { "x-access-token": localStorage.getItem("access-token") } })
			.then(res => {
				let max = 0;

				let data = {
					labels: [],
					datasets: [
						{
							label: "Number of Active Students",
							data: []
						},
					],
				};
				for (let metric of res.data) {
					if (metric.value > max) max = metric.value;
					data.datasets[0].data.push(metric.value);
					data.labels.push(moment(metric.timestamp).format("DD/MM HH:mm"))
				}
				setTotalCost(max * costPerStudent);
				setActiveStudentData(data);
			})
			.catch((err) => {
				toast.error("An unexpected error has occurred");
			});
	}, [timestamp, props.organization]); //eslint-disable-line

	if (props.user.accessLevel > 1) return null;

	return <Box>
		<Card sx={{ p: 2, mb: 2.5 }}>
			<CardContent sx={{ p: 0 }}>
				<Grid container spacing={2} alignItems="center">
					<Grid item xs={12} md={5}>
						<Typography variant="h6">Finance</Typography>
						<Typography sx={{ color: "text.secondary", mt: 0.5 }}>
							Track active student history and monthly platform cost.
						</Typography>
					</Grid>
					<Grid item xs={12} md={3}>
						<DatePicker
							views={['year', 'month']}
							label="Month"
							onChange={ts => setTimestamp(ts)}
							value={timestamp}
							slotProps={{ textField: { fullWidth: true } }}
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<Card sx={{ p: 1.5 }}>
							<Typography sx={{ color: "text.secondary", fontWeight: 700 }}>
								{timestamp.isSameOrAfter(moment().startOf("month")) ? "Expected Cost" : "Cost"}
							</Typography>
							<Typography sx={{ fontSize: { xs: 30, md: 34 }, fontWeight: 700, mt: 0.5 }} color="primary">
								{totalCost.toFixed(2)}€
							</Typography>
						</Card>
					</Grid>
				</Grid>
			</CardContent>
		</Card>

		<Card sx={{ p: 1.5 }}>
			<CardContent>
				<Line data={activeStudentData} />
			</CardContent>
		</Card>
	</Box>;
}

export default Finance;